import { render, staticRenderFns } from "./ArrowNarrowUp.vue?vue&type=template&id=5cda3dd1"
import script from "./ArrowNarrowUp.vue?vue&type=script&lang=js"
export * from "./ArrowNarrowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports